import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MaintenanceModeComponent} from './shared/components/pages/maintenance-mode/maintenance-mode.component';
import {MaintenanceModeGuard} from './shared/guards/maintenance-mode.guard';

const routes: Routes = [
  {
    path: 'maintenance',
    component: MaintenanceModeComponent
  },
  {
    path: 'portal',
    canActivate: [MaintenanceModeGuard],
    loadChildren: () => import('./portal-alumno/portal-alumno.module').then( m => m.PortalAlumnoModule)
  },
  {
    path: 'sgc',
    canActivate: [MaintenanceModeGuard],
    loadChildren: () => import('./sgc/sgc.module').then( m => m.SGCModule)
  },
  {
    path: '',
    canActivate: [MaintenanceModeGuard],
    loadChildren: () => import('./web/web.module').then( m => m.WebModule)
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
